<template>
  <form-section
    :title="$t('ApplicationForm_Row_AndroidPushNotificationSettingsTitle')"
  >
    <el-form :model="model" :disabled="readonly">
      <el-row>
        <el-col :span="14">
          <div>
            <form-item :label="$t('ApplicationForm_Field_ServiceAccountFile')">
              <el-upload
                drag
                action="#"
                :http-request="handleFile"
                :show-file-list="false"
                accept=".json"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  Drop file here or <em>click to upload</em>
                </div>
              </el-upload>
            </form-item>
          </div>
          <span
            v-if="
              isServiceAccountFileUploaded && !isNewServiceAccountFileUploaded
            "
            class="file-status"
          >
            {{ $t('ApplicationForm_Field_ServiceAccountFileActive') }}
          </span>
          <span v-if="isNewServiceAccountFileUploaded" class="file-status">
            {{ $t('ApplicationForm_Field_NewServiceAccountFileUploaded') }}
          </span>
        </el-col>
      </el-row>
    </el-form>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import FormItem from '@/common/components/form/FormItem'

export default {
  name: 'PushSettingsAndroid',
  components: { FormItem, FormSection },
  props: {
    model: {
      required: true,
      default: {
        new_android_key: null,
        new_android_service_account_config: null
      }
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isServiceAccountFileUploaded() {
      return this.model.android_service_account_config
    },

    isNewServiceAccountFileUploaded() {
      return this.model.new_android_service_account_config
    }
  },

  methods: {
    handleFile(option) {
      this.$emit('update:loading', true)
      const reader = new FileReader()
      reader.readAsText(option.file)

      reader.onload = () => {
        this.$set(
          this.model,
          'new_android_service_account_config',
          reader.result
        )

        this.$message({
          message: this.$t('Imports_Message_UploadedSuccessfully'),
          type: 'success'
        })
        this.$emit('update:loading', false)
      }

      reader.onerror = () => {
        this.$message({
          message: this.$t('Imports_Message_UploadError'),
          type: 'error'
        })
        this.$emit('update:loading', false)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.file-status {
  font-size: 12px;
  color: #7e8596;
}
.legacy-notice {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/settings/components/PushSettingsAndroid.vue